import React, {PureComponent} from "react"

import {Body} from "@irati/ui/src/Typography"
import {FormattedMessage, injectIntl, InjectIntl} from "@irati/utils/lang"
import EmojiWithText from "../EmojiWithText"

class FeaturesContent extends PureComponent<InjectIntl> {
  render() {
    const {formatMessage} = this.props
    return (
      <>
        <Body marginBottom={4}>
          <FormattedMessage id="medical.code.features.title" />
        </Body>
        <EmojiWithText emoji="iphone" text={formatMessage({id: "medical.code.features.text1"})} />
        <EmojiWithText emoji="date" text={formatMessage({id: "medical.code.features.text2"})} />
        <EmojiWithText emoji="ok_hand" text={formatMessage({id: "medical.code.features.text3"})} />
        <EmojiWithText emoji="video_camera" text={formatMessage({id: "medical.code.features.text4"})} />
      </>
    )
  }
}

export default injectIntl(FeaturesContent)
